export enum MeasureCategorisation {
    SUBSTITUTION = 'SUBSTITUTION',
    TECHNICAL = 'TECHNICAL',
    ORGANIZATIONAL = 'ORGANIZATIONAL',
    PERSONAL = 'PERSONAL'
}

export const MEASURE_CATEGORIZATION_KEY_PREFIX = 'ENUM.MEASURE.';
export const MEASURE_CATEGORIZATION_KEY_SUFIX = '.TXT';
